import { memo } from 'react';

import ButtonGroup from '../../../Controls/ButtonGroup/index.tsx';
import { Button } from '../../Controls/Button/index.tsx';
import { Notification } from '../../Feedback/Notifications/index.tsx';

interface ErrorBlockProps {
  errorBlockTitle?: string;
  tryAgainText?: string;
  onResetClick?: () => void;
  errors: string[];
}

export const ErrorBlock = memo(function ErrorBlock({
  errorBlockTitle = 'The upload failed due to the following errors',
  tryAgainText = 'Try again',
  errors,
  onResetClick,
}: ErrorBlockProps) {
  return (
    <Notification
      uncloseable
      type='error'
      fullWidth
      title={errorBlockTitle}
      body={
        <>
          <ul>
            {errors.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
          {onResetClick && (
            <ButtonGroup>
              <Button critical onClick={onResetClick}>
                {tryAgainText}
              </Button>
            </ButtonGroup>
          )}
        </>
      }
    />
  );
});
